import AuthManagement from "feathers-authentication-management/lib/client";
const feathers = require("feathers/client")
const rest = require("feathers-rest/client");
const hooks = require("feathers-hooks");
const localStorage = require("localstorage-memory");
const axios = require("axios");
const Promise = require('promise')
const moment = require("moment")
const constanteData = require('../helpers/constanteData')
const auth = require("feathers-authentication-client");

const app = feathers()
.configure(hooks())
.configure(rest(constanteData.SERVER_URL).axios(axios))
.configure(auth({ storage: window.localStorage }));

const authManagement = new AuthManagement(app);
 
export function reauthenticate() {
  return app.authenticate({
    strategy: 'jwt',
    accessToken: localStorage.getItem('feathers-jwt')
  }).then(response => {
    return app.passport.verifyJWT(response.accessToken);
  })
  .then(payload => {
    return app.service("users").get(payload.userId);
  })
  .then(user => {
    app.set('user', user);
    return Promise.resolve(app.get('user'));
   })
}
export function createAccount(data) {
  data.strategy = "local";
  return app
    .service("users")
    .create(data)
}
export function verifyUser(token) {
  return authManagement.verifySignupLong(token);
}
export function logout() {
  return app.logout();
}
export function login(email, password) {
  return app.authenticate({strategy: "local", email, password})
  .then(response => {
    return app.passport.verifyJWT(response.accessToken);
  })
  .then(payload => {
    return app.service("users").get(payload.userId);
  })
  .then(user => {
    app.set('user', user);
    return Promise.resolve(app.get('user'));
   })
}
export function loginCourtier(data) {
  return axios.post(constanteData.SERVER_URL + "/auth-courtier", data)
}
export function reauthenticateCourtier(jwt, service) {
  return axios
    .post(constanteData.SERVER_URL + '/auth-jwt', {token: jwt, entity: service})
    .then((res) => {
      return Promise.resolve(res.data)
    })
}
export function resendVerificationMail(email) {
  return authManagement.resendVerifySignup({ email });
}
export function saveSouscripteur(isCurrentLoginCourtier, userID, souscripteur) {
  if(isCurrentLoginCourtier) {
    return app.service("souscripteurs").create(souscripteur).then(res => {
      return res
    })
  }else {
    return app.service("souscripteurs").create(souscripteur).then(res => {
      return addSouscripteurtoUser(userID, res._id)
    })
  }
}
function addSouscripteurtoUser(userID, souscripteurID) {
  if(userID) {
    return app.service('users').patch(userID, {souscripteurID})
  }
}
export function updateSouscripteur(souscripteurID, data) {
  if(souscripteurID) {
    return app.service('souscripteurs').patch(souscripteurID, data)
  }
}
export function saveBeneficiaire(souscripteurID, beneficiaire) {
  beneficiaire.souscripteurID = souscripteurID;
  return app.service("beneficiaires").create(beneficiaire)
}
export function getAllBeneficiaire(souscripteurID) {
  return app.service("beneficiaires").find({query: {souscripteurID}})
}
export function updateBeneficiaire(beneficiaireID, data) {
  if(beneficiaireID) {
    return app.service('beneficiaires').patch(beneficiaireID, data)
  }
}
export function removeBeneficiaire(beneficiaireID) {
  if(beneficiaireID) {
    return app.service('beneficiaires').remove(beneficiaireID)
  }
}
export function saveQuestionnaire(beneficiaireID, questionnaire) {
  if(beneficiaireID) {
    return app.service("beneficiaires").patch(beneficiaireID, {questionnaire})
  }
}
export function getUser(id) {
  return app.service('users').get(id);
}
export function getSouscripteur(id) {
  return app.service('souscripteurs').get(id);
}
export function getAllClicks(codeParrain) {
  return app.service('users').find({
    query: {
      parentCode: codeParrain,
      isVerified: true,
    }
  })
}
export function getAllSouscriptions(codeParrain) {
  return app.service('souscripteurs').find({
    query: {
      parentCode: codeParrain,
      submitted: true
    }
  })
}
export function getWeekSouscriptions(codeParrain) {
  return app.service('souscripteurs').find({
    query: {
      parentCode: codeParrain,
      submitted: true,
      createdAt: {
        $gte: moment().startOf('week').valueOf()
      }
    }
  })
}
export function getActivatedPolicies(codeParrain) {
  return app.service('souscripteurs').find({
    query: {
      parentCode: codeParrain,
      policeActive: true
    }
  })
}
export function sendProfile(beneficiaireID, formData) {
  const config = {
    headers: { 'content-type': 'multipart/form-data' }
  }
  const url = `${constanteData.SERVER_URL}/uploads`;
  return axios
    .post(url, formData, config)
    .then((response) => {
      return updateBeneficiaire(beneficiaireID, {picture: response.data.id})
    })
}
export function getPicture(id) {
  return app.service("uploads").get(id)
}
export function updateUser(userID, data) {
  if(userID) {
    return app.service('users').patch(userID, data)
  }
}
export function changePassword(oldPassword, password, email, userID) {
  return authManagement.passwordChange(oldPassword, password, {email}).then( res => {
    return updateUser(userID, {password})
  })
}
export function sendEmail(data) {
  return app.service("admin-mail").create(data)
}
export function getCourtier(code) {
  return axios.get(`${constanteData.SERVER_URL}/courtier-logo`, {
    params: {codeApporteur: code}
  });
}
export function sendResetPwd(email) {
  return authManagement.sendResetPwd({email})
}
export function resetPwdLong(userID, token, password) {
  return authManagement.resetPwdLong(token, password).then( res => {
    return updateUser(userID, {password})
  })
}



// WEBPACK FOOTER //
// ./src/utils/ApiRest/backendMembers.js